import React from "react";
import { Nav } from "../components";

const Homepage = () => {
  return (
    <>
      <Nav />
      <div className="vh-100 d-flex align-items-center justify-content-center ">
        <div className="">
          <h2 className="text-center">
            ONDO STATE CONTRIBUTORY HEALTH COMMISSION (ODCHC)
          </h2>
          <h2 className="display-1 fw-bold text-center">ORANGHIS</h2>
        </div>
      </div>
    </>
  );
};

export default Homepage;
